// extracted by mini-css-extract-plugin
export default {"cellRenderer":"styles-module__cellRenderer__src-labstep-web-grid-Index-coldefs-Resource-entityLink-_xwqaM"};